/*!
 * ymm-drill.js — visual Fit Guide drill-down. Reads the vehicle from the URL query
 * (?make=&family=&model=&year=), renders the current step as a grid of tiles from the local tree,
 * uses history.pushState so Back walks the steps, and links the final step to a tag-filtered collection.
 * No network, no deps. Config via data-* on the mount:
 *   data-collection  (e.g. "/collections/all")   data-bike-base (optional image URL prefix)
 */
(function (w) {
  'use strict';
  // YEAR-FIRST cascade — matches the source engine's /shop-by-bike/{year}/{make}/{family}/{model} path.
  var AXES = ['year', 'make', 'family', 'model'];
  function el(t, c, h) { var e = document.createElement(t); if (c) e.className = c; if (h != null) e.innerHTML = h; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  // Deterministic per-bike pick so different screen-only bikes vary their "no factory ___" noun.
  function hashStr(s) { s = String(s || ''); var h = 0; for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0; return h; }

  function YMMDrill(mount) {
    this.el = typeof mount === 'string' ? document.querySelector(mount) : mount;
    if (!this.el) return;
    this.collection = this.el.getAttribute('data-collection') || '/collections/all';
    this.pageTitle = this.el.getAttribute('data-title') || 'Fit Guide';
    var self = this;
    this.el.classList.add('ymm-drill');
    w.addEventListener('popstate', function () { self.render(); });
    w.addEventListener('pageshow', function (e) { if (e.persisted) self.render(); }); // bfcache guard
    w.YMM.onReady(function () { self.render(); });
  }

  YMMDrill.prototype.params = function () {
    var q = new URLSearchParams(w.location.search), s = {};
    AXES.forEach(function (a) { var v = q.get(a); if (v) s[a] = a === 'year' ? parseInt(v, 10) : v; });

    // NORMALISE an inbound ?model= (Joe, 2026-07-16: "clicking fitment pills ... lands at the wrong spot
    // in the fitment engine, 1 category up").
    // step() returns the first axis with NO value, so a link carrying year+make+model but no FAMILY
    // stopped at "Choose a family" and silently ignored the model. The fits-list chips link exactly that
    // way — and they can't just add &family=: the fit: tag carries the FITMENT family ("touring") while
    // the drill navigates by VISUAL family ("Electra Glide"). Different axes; passing ffam here would
    // land on a family that doesn't exist in this nav.
    // The chips also pass a SLUG ("electra-glide") while tiles use real names ("Electra Glide"), so even
    // a correct family wouldn't have matched.
    // Fix both HERE rather than in the link: findModel() already resolves slug→name AND gives the vfam,
    // so ANY inbound ?model= now works — from the chips, a hand-typed URL, or anything built later.
    if (s.make && s.model && w.YMM && w.YMM.findModel) {
      var hit = w.YMM.findModel(s.make, s.model);
      if (hit) {
        s.model = hit.model;                 // slug → the real catalogue name the tiles use
        if (s.family == null) s.family = hit.vfam;
      } else {
        delete s.model;                      // unknown model: drop it rather than wedge on a dead step
      }
    }
    return s;
  };
  YMMDrill.prototype.urlFor = function (sel) {
    var q = new URLSearchParams();
    AXES.forEach(function (a) { if (sel[a] != null) q.set(a, sel[a]); });
    return w.location.pathname + '?' + q.toString();
  };
  YMMDrill.prototype.go = function (sel) {
    w.history.pushState(sel, '', this.urlFor(sel));
    this.render();
    try { w.scrollTo({ top: this.el.getBoundingClientRect().top + w.pageYOffset - 80, behavior: 'smooth' }); } catch (e) {}
  };

  // which step are we on? the first axis without a value
  YMMDrill.prototype.step = function (sel) {
    for (var i = 0; i < AXES.length; i++) if (sel[AXES[i]] == null) return AXES[i];
    return null; // complete
  };

  // Tiles for the current step, each constrained by the year picked first.
  YMMDrill.prototype.tiles = function (axis, sel) {
    var out = [];
    if (axis === 'year') out = w.YMM.years().map(function (y) { return { v: y, label: y, img: null }; });
    else if (axis === 'make') out = w.YMM.makes(sel.year).map(function (m) { return { v: m.key, label: m.name, img: 'make-' + m.key }; });
    else if (axis === 'family') out = w.YMM.families(sel.make, sel.year).map(function (f) { return { v: f, label: f, img: 'family-' + w.YMM.slug(f) }; });
    else if (axis === 'model') out = w.YMM.models(sel.make, sel.family, sel.year).map(function (m) {
      var n = w.YMM.nodeOf(sel.make, sel.family, m); return { v: m, label: m, img: (n && n.img) || w.YMM.slug(m) };
    });
    return out;
  };
  // Resolve a tile image slug → a real theme asset URL (Shopify CDN URLs are hashed, so Liquid hands us a map).
  YMMDrill.prototype.imgUrl = function (slug) {
    if (!slug) return null;
    var map = w.YMM_BIKES || {};
    return map[slug] || null;
  };

  YMMDrill.prototype.render = function () {
    var self = this, sel = this.params(), step = this.step(sel);
    this.el.innerHTML = '';
    this.el.appendChild(this.crumb(sel));

    if (step) {
      var labels = { year: 'Choose your year', make: 'Choose your make', family: 'Choose a family', model: 'Choose your model' };
      this.el.appendChild(el('h2', 'ymm-drill__title', esc(labels[step])));
      var grid = el('div', 'ymm-grid ymm-grid--' + step);
      this.tiles(step, sel).forEach(function (t) {
        var next = Object.assign({}, sel); next[step] = t.v;
        var a = el('a', 'ymm-tile');
        a.href = self.urlFor(next);
        var url = self.imgUrl(t.img);
        // make tiles are brand LOGOS → contain (never crop). model/family tiles are photos → cover.
        var isLogo = (step === 'make');
        // No photo for this family/model (e.g. we have zero Indian photography) → fall back to the
        // make's brand logo rather than a 2-letter text tile. Text remains the last resort.
        if (!url && sel.make) { url = self.imgUrl('make-' + sel.make); if (url) isLogo = true; }
        var imgCls = 'ymm-tile__img' + (isLogo ? ' ymm-tile__img--logo' : '');
        var media = url
          ? '<span class="' + imgCls + '" style="background-image:url(\'' + url + '\')"></span>'
          : '<span class="ymm-tile__img ymm-tile__img--text">' + esc(String(t.label).slice(0, 2)) + '</span>';
        a.innerHTML = media + '<span class="ymm-tile__label">' + esc(t.label) + '</span>';
        a.addEventListener('click', function (e) { e.preventDefault(); self.go(next); });
        grid.appendChild(a);
      });
      this.el.appendChild(grid);
      try { document.title = self.pageTitle + ' — ' + (labels[step] || ''); } catch (e) {}
    } else {
      // complete → set garage + show result CTA
      var veh = w.YMM.buildVehicle(sel);
      if (veh && w.YMMGarage) w.YMMGarage.set(veh);
      var box = el('div', 'ymm-drill__result');
      var cls = (w.YMM.fitClass && w.YMM.fitClass(veh)) || 'fits';
      if (cls === 'screen-only') {
        // Joe 2026-07-18: no factory audio → offer a standalone HogPlay Media Screen (promote the Pro/DVR),
        // NOT a bypass/media-box. Link the SCREENS CATEGORY (not a single sku). Media Box on Screens = in dev.
        var nouns = ['radio', 'stereo', 'touchscreen', 'head unit'];
        var noun = nouns[Math.abs(hashStr(veh.label)) % nouns.length];
        box.className = 'ymm-drill__result ymm-drill__result--screen';
        box.innerHTML =
          '<h2 class="ymm-drill__title">No factory ' + noun + ' on your ' + esc(veh.label) + '?</h2>' +
          '<p class="ymm-drill__sub">Add wireless Apple CarPlay &amp; Android Auto anyway. Most riders settle for ' +
          'Bluetooth-only kits — phone stuck in your pocket, no turn-by-turn directions, no Pandora, none of the real ' +
          'CarPlay or Android Auto features. A standalone <a href="/collections/hogplay-media-screens">HogPlay Media Screen</a> ' +
          'is a 7-inch stereo with wireless CarPlay and Android Auto, live Maps &amp; Waze navigation and streaming right on the ' +
          'bars — we recommend the <strong>Screen 7 Pro</strong> with its onboard DVR drive-cam. It bolts to your ' + esc(veh.label) +
          ' handlebars with basic power and ground, so <a href="/pages/contact">reach out to the HogPlay team</a> if you want a hand. ' +
          '<em>(<a href="/collections/hogplay-media-boxes">Media Box</a> support on Screens is in development.)</em></p>' +
          '<a class="btn btn--primary ymm-drill__cta" href="/collections/hogplay-media-screens">Shop HogPlay Screens &rarr;</a>' +
          '<button type="button" class="ymm-drill__restart">Start over</button>';
      } else {
        var tag = w.YMM.fitTag(veh);
        var link = w.YMM.fitUrl(veh, w.YMM_FIT_COLLECTIONS, this.collection);
        var n = tag ? this.countFits(veh) : 0;
        box.innerHTML =
          '<h2 class="ymm-drill__title">' + esc(veh.label) + '</h2>' +
          '<p class="ymm-drill__sub">We found <strong>' + n + '</strong> part' + (n === 1 ? '' : 's') + ' that fit your bike.</p>' +
          '<a class="btn btn--primary ymm-drill__cta" href="' + esc(link) + '">See parts that fit &rarr;</a>' +
          '<button type="button" class="ymm-drill__restart">Start over</button>';
      }
      box.querySelector('.ymm-drill__restart').addEventListener('click', function () { self.go({}); });
      this.el.appendChild(box);
      try { document.title = (cls === 'screen-only' ? 'Add CarPlay to your ' : 'Parts that fit ') + veh.label; } catch (e) {}
    }
  };

  YMMDrill.prototype.countFits = function (veh) {
    var sel = w.YMM.selFromVehicle(veh);
    // productCount, NOT productSkus().length — the headline number must match the collection the
    // "See parts that fit" button lands on. SKUs double-count multi-variant products and include drafts:
    // a 2026 CVO Street Glide is 16 skus but 12 visible products. Joe saw exactly that mismatch.
    return w.YMM.productCount(sel, false); // includes universal
  };

  YMMDrill.prototype.crumb = function (sel) {
    var self = this, nav = el('nav', 'ymm-crumb'), parts = [];
    var acc = {};
    parts.push({ label: 'All bikes', sel: {} });
    AXES.forEach(function (a) { if (sel[a] != null) { acc = Object.assign({}, acc); acc[a] = sel[a]; parts.push({ label: a === 'make' ? w.YMM.makeName(sel[a]) : sel[a], sel: Object.assign({}, acc) }); } });
    parts.forEach(function (p, i) {
      if (i) nav.appendChild(el('span', 'ymm-crumb__sep', '›'));
      if (i === parts.length - 1) { nav.appendChild(el('span', 'ymm-crumb__cur', esc(String(p.label)))); return; }
      var a = el('a', 'ymm-crumb__link', esc(String(p.label)));
      a.href = self.urlFor(p.sel);
      a.addEventListener('click', function (e) { e.preventDefault(); self.go(p.sel); });
      nav.appendChild(a);
    });
    return nav;
  };

  w.YMMDrill = YMMDrill;
  // auto-mount
  document.addEventListener('DOMContentLoaded', function () {
    var m = document.querySelector('[data-ymm-drill]');
    if (m) new YMMDrill(m);
  });
})(window);
